import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiScoping } from '@/lib/api/scoping'
import { assessmentKeys } from '@/features/assessments/api/query-keys'

async function deleteAssessment(id: string): Promise<void> {
  await apiScoping.delete(`/api/v1/plant-assessment/${id}`)
}

export function useDeleteAssessment() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteAssessment,
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: assessmentKeys.lists() })
    },
  })
}
